<div class="section-ai-request pl-20">
    @if (filesWithFileName().length) {
        <div class="pt-10 text-right">
            @for (file of filesWithFileName(); track $index) {
                <div class="plate-container d-inline-flex">
                    <div class="plate plate-thin plate-noshadow plate-white">
                        <div class="plate-header width-full">
                            <div class="plate-title min-width-0">
                                <div class="plate-title-icon">
                                    <svg ycnIcon [name]="file.icon"></svg>
                                </div>
                                <div class="plate-title-name min-width-0 text-ellipsis">{{ file.fileName }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
    <div class="text-large leading-aire mb-1 text-prewrap text-right">{{ displayText() }}</div>
    <div class="section-ai-request-actions d-flex align-items-center justify-content-end">
        @if (saved()) {
            <div class="d-flex align-items-center text-small text-gray-30 mr-1">
                <svg ycnIcon name="icon-check" class="fill-current text-smallest mr-1" role="img"></svg>
                <span>Prompt has been saved to&nbsp;<a class="ai-prompt-saved text-underline text-gray-30"
                    [href]="promptLibraryUrl"
                    (click)="promptLibraryClicked.emit($event)">Prompt Library</a>.</span>
            </div>
        }
        @if (savePromptEnabled()) {
            <button
                class="btn btn-circle btn-xs btn-transparent btn-lightgray"
                ycnTooltip
                [tooltipTitle]="saved() ? 'Saved prompt' : 'Save prompt'"
                [tooltipPlacement]="'bottom'"
                [disabled]="saving() || saved()"
                (click)="savePrompt()">
                @if (saving()) {
                    <div class="loader-spinner-context loader-xs"></div>
                } @else if (showSavedCheck()) {
                    <svg ycnIcon name="icon-check" class="text-blue-ada fill-current" role="img"></svg>
                } @else if (saved()) {
                    <svg ycnIcon name="icon-bookmark-filled" class="text-blue-ada fill-current" role="img"></svg>
                } @else {
                    <svg ycnIcon name="icon-bookmark" role="img"></svg>
                }
            </button>
        }
        <button
            class="btn btn-circle btn-xs btn-transparent btn-lightgray"
            ycnTooltip
            [tooltipTitle]="copied() ? 'Copied!' : 'Copy'"
            [tooltipPlacement]="'bottom'"
            (click)="copyText()">
            <svg ycnIcon [name]="copied() ? 'icon-check' : 'icon-copy'" role="img"></svg>
        </button>
    </div>
</div>
